export const CANVAS_SIZE = {
  width: 3500,
  height: 2000,
};
